import React, { useState } from 'react';
import RechteMatrix from './RechteMatrix';
import RechteBenutzer from './RechteBenutzer';
import RechteZuweisungen from './RechteZuweisungen';

type Tab = 'rollen' | 'benutzer' | 'zuweisungen';

const TABS: { id: Tab; label: string }[] = [
  { id: 'rollen', label: 'Rollen' },
  { id: 'benutzer', label: 'Benutzer' },
  { id: 'zuweisungen', label: 'Zuweisungen' },
];

/** Einstellungen -> Rechte: Rollenmatrix, Benutzer-Overrides, Auftrags-/Projektzuweisungen. */
const RechteSection: React.FC = () => {
  const [tab, setTab] = useState<Tab>('rollen');

  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Rechte</h3>
      <p style={{ color: 'var(--ink-2)', marginBottom: 16, fontSize: 14 }}>
        Legt fest, was welche Rolle sehen und tun darf. Einzelne Benutzer können mehrere Rollen
        haben und Abweichungen erhalten; Zuweisungen geben Zugriff auf einzelne Aufträge oder Projekte.
      </p>
      <div style={{ display: 'flex', gap: 6, marginBottom: 18, flexWrap: 'wrap' }}>
        {TABS.map(t => (
          <button
            key={t.id}
            type="button"
            className={`k-btn k-btn--sm ${tab === t.id ? 'k-btn--primary' : 'k-btn--ghost'}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'rollen' && <RechteMatrix />}
      {tab === 'benutzer' && <RechteBenutzer />}
      {tab === 'zuweisungen' && <RechteZuweisungen />}
    </div>
  );
};

export default RechteSection;
